export default __webpack_public_path__ + "static/media/juice-mug.cb4edeae.jpg";